import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AvailabilityComboChangesetComponent,
  BundleChangesetComponent,
  ComboChangesetComponent,
  KidMealChangesetComponent,
  LtoChangesetComponent,
  PricingComponent,
  SubstitutionChangesetComponent,
  UpchargeChangesetComponent,
} from './components';
import { AvailabilityComponent } from './components';
import {
  CHANGESET_ROW,
  GridRowAlacarteAvailabilityChangeset,
  GridRowAllAvailabilityChangeset,
  GridRowDMBAvailabilityChangeset,
  GridRowDMBChangeset,
  GridRowModifierAvailabilityChangeset,
  GridRowModifierChangeset,
  GridRowModifierCodesChangeset,
  GridRowPricingChangeset,
  GridRowPromoAvailabilityChangeset,
  GridRowPromoChangeset,
  GridRowSubstitutionAvailabilityChangeset,
  GridRowUpchargeAvailabilityChangeset,
} from './models';
import { BasePricingChangesetComponent } from './components/base-pricing-changeset/base-pricing-changeset.component';
import { BaseAvailabilityChangesetComponent } from './components/base-availability-changeset/base-availability-changeset.component';

const routes: Routes = [
  {
    path: 'pricing',
    component: PricingComponent,
    children: [
      {
        path: 'combo',
        component: ComboChangesetComponent,
      },
      {
        path: 'kidmeal',
        component: KidMealChangesetComponent,
      },
      {
        path: 'substitution',
        component: SubstitutionChangesetComponent,
      },
      {
        path: 'upcharge',
        component: UpchargeChangesetComponent,
      },
      {
        path: 'lto',
        component: LtoChangesetComponent,
      },
      {
        path: 'bundle',
        component: BundleChangesetComponent,
      },
      {
        path: 'aLaCarte',
        component: BasePricingChangesetComponent,
        providers: [
          {
            provide: CHANGESET_ROW,
            useValue: GridRowPricingChangeset,
          },
        ],
      },
      {
        path: 'dmb',
        component: BasePricingChangesetComponent,
        providers: [
          {
            provide: CHANGESET_ROW,
            useValue: GridRowDMBChangeset,
          },
        ],
      },
      {
        path: 'modifier',
        component: BasePricingChangesetComponent,
        providers: [
          {
            provide: CHANGESET_ROW,
            useValue: GridRowModifierChangeset,
          },
        ],
      },
      {
        path: 'promo',
        component: BasePricingChangesetComponent,
        providers: [
          {
            provide: CHANGESET_ROW,
            useValue: GridRowPromoChangeset,
          },
        ],
      },
      {
        path: 'others',
        component: BasePricingChangesetComponent,
        providers: [
          {
            provide: CHANGESET_ROW,
            useValue: GridRowPricingChangeset,
          },
        ],
      },
      {
        path: 'modifiercodes',
        component: BasePricingChangesetComponent,
        providers: [
          {
            provide: CHANGESET_ROW,
            useValue: GridRowModifierCodesChangeset,
          },
        ],
      }
    ],
  },
  {
    path: 'availability',
    component: AvailabilityComponent,
    children: [
      {
        path: 'combo',
        component: AvailabilityComboChangesetComponent,
      },
      {
        path: 'kidmeal',
        component: AvailabilityComboChangesetComponent,
      },
      {
        path: 'substitution',
        component: BaseAvailabilityChangesetComponent,
        providers: [
          {
            provide: CHANGESET_ROW,
            useValue: GridRowSubstitutionAvailabilityChangeset,
          },
        ],
      },
      {
        path: 'upcharge',
        component: BaseAvailabilityChangesetComponent,
        providers: [
          {
            provide: CHANGESET_ROW,
            useValue: GridRowUpchargeAvailabilityChangeset,
          },
        ],
      },
      {
        path: 'aLaCarte',
        component: BaseAvailabilityChangesetComponent,
        providers: [
          {
            provide: CHANGESET_ROW,
            useValue: GridRowAlacarteAvailabilityChangeset,
          },
        ],
      },
      {
        path: 'dmb',
        component: BaseAvailabilityChangesetComponent,
        providers: [
          {
            provide: CHANGESET_ROW,
            useValue: GridRowDMBAvailabilityChangeset,
          },
        ],
      },
      {
        path: 'modifier',
        component: BaseAvailabilityChangesetComponent,
        providers: [
          {
            provide: CHANGESET_ROW,
            useValue: GridRowModifierAvailabilityChangeset,
          },
        ],
      },
      {
        path: 'promo',
        component: BaseAvailabilityChangesetComponent,
        providers: [
          {
            provide: CHANGESET_ROW,
            useValue: GridRowPromoAvailabilityChangeset,
          },
        ],
      },
      {
        path: 'others',
        component: BaseAvailabilityChangesetComponent,
        providers: [
          {
            provide: CHANGESET_ROW,
            useValue: GridRowAlacarteAvailabilityChangeset,
          },
        ],
      },
      {
        path: 'all',
        component: BaseAvailabilityChangesetComponent,
        providers: [
          {
            provide: CHANGESET_ROW,
            useValue: GridRowAllAvailabilityChangeset,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RestaurantItemRoutingModule {}
